require('./accountLastMovementsFilter.scss');

const PropTypes = require('prop-types');

const React = require('react');
const moment = require('moment');
// @ helpers
const { getLanguage } = require('core/i18n').i18n;
const {formatCurrency} = require('utilities/currencyHelper');
// @ commons
const OKModal = require('components/commons/OKModal/OKModal');
// @ components
const { AmountFilter } = require('commonsComponents/amountFilter');
import { OKInput } from 'commonsComponents/OKInput';

const DateFilter = require('components/commons/dateFilter/dateFilter');
const MovementTypeFilter = require('components/commons/movementTypeFilter/movementTypeFilter.js');
// @ constants
const { EURO_TEXT } = require('constants/index');
const DATE_FILTER_MIN_DATE_LIMIT = moment().startOf('day').subtract(2, 'years');
const { AMOUNT_FILTER_LABEL, AMOUNT_FILTER_GREATER_THAN, AMOUNT_FILTER_LOWER_THAN } = require('constants/commonsComponents');
const { NOT_ALLOWED_ACCOUNTS_SEARCH_AND_AMOUNT_FILTERS_COUNTRIES} = require('constants/flagBasedFeatures');
//@core
const { formatText } = require('core/i18n').i18n;

class AccountLastMovementsFilter extends React.Component {

    constructor(props) {
        super(props);

        const { immFilter } = props;

        this.state = {
            dateSelected: immFilter.getIn(['date','selected']),
            dateFrom: immFilter.getIn(['date','from']),
            dateTo: immFilter.getIn(['date','to']),
            amountFrom: immFilter.getIn(['amount','from','amount']),
            amountTo: immFilter.getIn(['amount','to','amount']),
            concept: immFilter.getIn(['concept','concept']),
            movementType: immFilter.getIn(['movementType','movementType']),
            newTextFilterValue:immFilter.getIn(['description', 'selected'])

        };

        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleChangeAmountMin = this.handleChangeAmountMin.bind(this);
        this.handleChangeAmountMax = this.handleChangeAmountMax.bind(this);
        this.handleChangeDateMin = this.handleChangeDateMin.bind(this);
        this.handleChangeDateMax = this.handleChangeDateMax.bind(this);
        this.handleChangeDateSelected = this.handleChangeDateSelected.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.handleConceptChange = this.handleConceptChange.bind(this);
        this.handleNewTextFilter=this.handleNewTextFilter.bind(this);

    }

    handleNewTextFilter(event) {
        this.setState({newTextFilterValue:event.target.value});
    }

    handleChangeAmountMax(amountTo) {
        this.setState({
            amountTo
        });
    }

    handleChangeAmountMin(amountFrom) {
        this.setState({
            amountFrom
        });
    }

    handleChangeDateMax(dateTo) {
        this.setState({
            dateTo
        });
    }

    handleChangeDateMin(dateFrom) {
        this.setState({
            dateFrom
        });
    }

    handleChangeDateSelected(dateSelected) {
        this.setState({
            dateSelected
        });
    }

    handleConceptChange(concept) {
        this.setState({
            concept
        });
    }

    handleInstructionMessage(textFilterValue){
        const charsLeft = 100 - textFilterValue.length;
        const message = formatText('transfers-charactersLeft', [charsLeft]);
        return message;
    }

    handleFormSubmit() {
        const {
            accountCurrency,
            accountId,
            immTransactions,
            onCloseClick,
            setFilter,
            toggleAccountMovementsScaModal
        } = this.props;
        const {dateFrom, dateTo, dateSelected, amountFrom, amountTo, movementType, concept,newTextFilterValue} = this.state;

        setFilter({
            date: {
                selected: dateSelected,
                from: dateFrom,
                to: dateTo
            },
            amount: {
                from: {
                    currency: accountCurrency,
                    amount: amountFrom
                },
                to: {
                    currency: accountCurrency,
                    amount: amountTo
                }
            },
            description:{
                isActive: !!newTextFilterValue,
                selected: newTextFilterValue
            },
            movementType: {
                movementType
            },
            concept: {
                concept
            }
        });

        if (immTransactions.get('scaRequiredAccountModal')) {
            toggleAccountMovementsScaModal(accountId);
        }

        onCloseClick();
    }

    handleTypeChange(movementType) {
        this.setState({
            movementType
        });
    }

    render() {
        const { onCloseClick, immFilter, isCredit, accountCurrency, immProfile,flagBasedFeatures } = this.props;
        const { amountFrom, amountTo ,newTextFilterValue} = this.state;
        const allowedAmountAndTextFiltersCountries = flagBasedFeatures.get(NOT_ALLOWED_ACCOUNTS_SEARCH_AND_AMOUNT_FILTERS_COUNTRIES);

        let movementTypeFilter;

        if (!isCredit) {
            movementTypeFilter = (
                <MovementTypeFilter
                    immFilter={immFilter}
                    onConceptChange={this.handleConceptChange}
                    onTypeChange={this.handleTypeChange}
                    immProfile={immProfile}
                />
            );
        }

        const content = (
            <section className="account-last-movements-filter modal-container">
                   {allowedAmountAndTextFiltersCountries && 
                   <OKInput   
                        onChange={this.handleNewTextFilter}
                        placeholder={formatText('myMoneyTransactions-textFilterPlaceholder')}
                        value={newTextFilterValue}
                        maxLength="100"
                        instructionsMessage={this.handleInstructionMessage(newTextFilterValue)}
                    />} 
                <DateFilter
                    immFilter={immFilter.get('date')}
                    onChangeMin={this.handleChangeDateMin}
                    onChangeMax={this.handleChangeDateMax}
                    onChangeSelected={this.handleChangeDateSelected}
                    minDate={DATE_FILTER_MIN_DATE_LIMIT}
                    showTwoYears={true}
                />
                <AmountFilter
                    immFilter={immFilter}
                    onChangeMin={this.handleChangeAmountMin}
                    onChangeMax={this.handleChangeAmountMax}
                    fromValue={amountFrom}
                    toValue={amountTo}
                    currencySymbol={formatCurrency(accountCurrency)}
                    amountLabel={AMOUNT_FILTER_LABEL}
                    greaterThan={AMOUNT_FILTER_GREATER_THAN}
                    lowerThan={AMOUNT_FILTER_LOWER_THAN}
                    language={getLanguage()}
                />
                {movementTypeFilter}
            </section>
        );

        return (
            <OKModal
                content={content}
                footerType="navigation"
                isOpen={true}
                onCloseCallback={onCloseClick}
                onPrimaryButtonClick={this.handleFormSubmit}
                onSecondaryButtonClick={onCloseClick}
                primaryButtonText="filterDate-apply"
                secondaryButtonText="filterDate-cancel"
                title="accounts-filterMovements"
                titleTooltip="accountMovements-filterTooltip"
                size="large"
            />
        );
    }
}

AccountLastMovementsFilter.propTypes = {
    accountId: PropTypes.string.isRequired,
    accountCurrency: PropTypes.string.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    isCredit: PropTypes.bool.isRequired,
    immTransactions: PropTypes.object.isRequired,
    immFilter: PropTypes.object,
    setFilter: PropTypes.func,
    toggleAccountMovementsScaModal: PropTypes.func.isRequired,
    immProfile: PropTypes.object.isRequired,
    flagBasedFeatures: PropTypes.object

}

AccountLastMovementsFilter.defaultProps = {
    accountCurrency: EURO_TEXT
}

module.exports = AccountLastMovementsFilter;
